import React, { memo } from 'react'
import { Handle, Position } from '@xyflow/react'

const StartNode = memo(({ data, selected }) => {
    const hasModel = !!data.availableModel
    const hasTrigger = !!data.triggerType

    return (
        <div className={`wf-node wf-node-start ${selected ? 'wf-node-selected' : ''}`}>
            <div className="wf-node-header wf-node-header-start">
                <i className="fa fa-bolt" /> Trigger
            </div>
            <div className="wf-node-body">
                {data.name ? (
                    <div className="wf-node-title">{data.name}</div>
                ) : (
                    <div className="wf-node-placeholder">Click to configure</div>
                )}
                {hasModel && (
                    <div className="wf-node-tag">
                        {data.availableModel.contentType?.model?.toUpperCase() || data.contentTypeModel?.toUpperCase() || 'Model'}
                    </div>
                )}
                {hasTrigger && (
                    <div className="wf-node-tag">
                        {data.triggerType.replaceAll('_', ' ')}
                    </div>
                )}
                {!hasModel && !hasTrigger && !data.name && (
                    <div className="wf-node-hint">Set name, model & trigger type</div>
                )}
            </div>
            <Handle type="source" position={Position.Bottom} className="wf-handle" />
        </div>
    )
})

StartNode.displayName = 'StartNode'
export default StartNode
